import { BrandKit, defaultBrandKit } from "@redotech/redo-model/brand-kit";
import { createContext, Dispatch, SetStateAction } from "react";
import { ReviewsFormForm } from "./review-form-types";

export const ReviewFormContext = createContext<ReviewsFormForm | undefined>(
  undefined,
);

export const BrandKitContext = createContext<BrandKit>(defaultBrandKit);

export const THANK_YOU_UPSELL_PAGE = "thank-you-upsell-page";
export type THANK_YOU_UPSELL_PAGE = typeof THANK_YOU_UPSELL_PAGE;

export type ReviewFormSelection = {
  selectedPageIndex: number | THANK_YOU_UPSELL_PAGE;
  selectedElementIndex: number | null;
};
export const ReviewFormSelectionContext = createContext<ReviewFormSelection>({
  selectedPageIndex: 0,
  selectedElementIndex: null,
});

export const SetReviewFormSelectionContext = createContext<
  Dispatch<SetStateAction<ReviewFormSelection>>
>(() => {});

export const UsedSemanticTagsContext = createContext<string[]>([]);

export interface ProductBeingReviewed {
  imageUrl: string;
  title: string;
  purchaseDate: Date;
}
export const exampleProduct: ProductBeingReviewed = {
  imageUrl:
    "https://s3-alpha-sig.figma.com/img/7709/d759/f3989ac5bbca1e59fd0c66039953ddfe?Expires=1730073600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=njxUZWfa~EKhpZ3FdXPz9JAsncGsD391~S76iCDW6lWXO~eS5OA28VVhkLNKkANuX~bSAHXMOPbANimObNzkuUiGrfsz0JH1B-vh-weTibcjhvR-Ss2KR0p34Jr2xnSqN~rmGq3jR-hy7QyfiFgr6P~r9fpWwTR6e6QGxu1~HDFI9COQ8lKxa758hzzkJ8ACyKiKpPOrcsVuFCxkq-gCyB2LazkDe2n2VV20Hh6266osAAzw1J2IJV0crE7ldX4BI0J0RV9JXhK5UTde5JBsIzhMGp2282kduSrZG~bb3uo6SAJWGFZc1lc8D-e~dAH1LwiwL2KCjR-Wolhu89~PZQ__",
  title: "Product title",
  purchaseDate: new Date(),
};
export const ProductBeingReviewedContext =
  createContext<ProductBeingReviewed>(exampleProduct);

export interface DiscountContext {
  formattedDiscountString: string;
  discountCode: string;
}
export const DiscountContext = createContext<DiscountContext | null>(null);
